<template>
  <div class="slide-transition">
    <transition name="slide"

                appear>
      <slot />
    </transition>
  </div>
</template>

<script>

export default {

  name: "SlideTransition",

};

</script>

<style scoped>
  .slide-transition {
    position: relative;
  }

  .slide-leave-active,
  .slide-enter-active {
    transition: 0.75s;
  }

  .slide-enter {
    transform: translate( 100%, 0 );
  }

  .slide-leave-active,
  .slide-leave-to {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

  }

  .slide-leave-to {
    transform: translate( -100%, 0 );
  }
</style>
